import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { BrowserUtils } from "@azure/msal-browser";
import { FailedComponent } from './failed/failed.component';
import { UnAthourisedComponent } from './un-athourised/un-athourised.component';
import { AuthGuard } from './shared/services/auth.guard';

const routes: Routes = [

  {
    path: '',
    loadChildren: () => import('./main/main.module').then(m => m.MainModule),
    canActivate: [
      MsalGuard ,
      AuthGuard
    ]
  },
  {
    path:'un-authorised',
    component:UnAthourisedComponent
  },
  {
    path:'login-failed',
    component:FailedComponent
  },
  { path: '**', redirectTo: '' }
  
];

@NgModule({
  imports: [
    RouterModule.forRoot((routes), {
        useHash: true,
        preloadingStrategy: PreloadAllModules,
        // Don't perform initial navigation in iframes or popups
        initialNavigation: !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup() ? 'enabledNonBlocking' : 'disabled', // Set to enabledBlocking to use Angular Universal
        enableTracing: false,
        onSameUrlNavigation: 'reload',
        canceledNavigationResolution: 'replace'
    })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
